<script>
  export let id;
  export let contributors = [];
  export let ulClasses;
  export let liClasses;
</script>

<ul {id} aria-label="Donor Search Results" tabindex="-1" class={ulClasses}>
  {#each contributors as contributor}
    <li class={liClasses}>{contributor.name}</li>
  {/each}
</ul>
